var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-tab-nav"},[_c('div',{staticClass:"ai-tab-list"},_vm._l((_vm.tabs),function(t){return _c('div',{key:t.name,class:['ai-tab', { active: _vm.current === t.name }],on:{"click":function($event){return _vm.go(t.name)}}},[_c('i',{class:t.icon,staticStyle:{"margin-right":"6px"}}),_vm._v(" "+_vm._s(t.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }